import { h } from "preact";

export default function MiniCartItemBadge({ item, position, className }) {
  const badge = item.properties?._badge;
  const badgeColor = item.properties?._badge_color || null;
  const badgePosition = item.properties?._badge_position || "Default";
  if (!badge || badgePosition !== position) return null;

  // For backwards compatibility - previously the badge contained embedded color info
  const [text] = badge.split("||");

  return (
    <div className={className} style={{ "--badge-color": badgeColor }}>
      {text}
    </div>
  );
}
